import React from 'react'
import LandingPageContainer from '../containers/landingPageContainer'

export const LandingPage = ({ user, isAdmin, location }) => <LandingPageContainer user={user} isAdmin={isAdmin} location={location} />

export default LandingPage